export const getCustomStyles = () => {
      const customStyles = {
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(240, 240, 240, 0.75)',
          zIndex: 1050, 
        },
        content: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          bottom: 'auto',
          transform: 'translate(-50%, -50%)',
          border: '1px solid #C1E0F8',
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          borderRadius: '20px',
          outline: 'none',
          
          // padding: '20px'
        }
      };
      
      return customStyles;
    };